import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import BannerGlobal from '../../Components/Banner/BannerGlobal'
import BlogComponent2 from '../../Components/BlogComponent/BlogComponent2'
import ContactComponent from '../../Components/ContactComponent/ContactComponent'
import useDocumentTitle from '../../PageTitle'

const Blogs = () => {
  useDocumentTitle("Roofing | Blogs")
  return (
    <div>
        <Header/>
        <BannerGlobal/>
        <BlogComponent2/>
        <ContactComponent/>

        <Footer/>
    </div>
  )
}

export default Blogs